import { render, staticRenderFns } from "./FeedbackDocument.vue?vue&type=template&id=b7abcb8c&scoped=true"
import script from "./FeedbackDocument.vue?vue&type=script&lang=js"
export * from "./FeedbackDocument.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDocument.vue?vue&type=style&index=0&id=b7abcb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7abcb8c",
  null
  
)

export default component.exports